import { render, staticRenderFns } from "./DashboardMonetizedUsers.vue?vue&type=template&id=4e732372"
import script from "./DashboardMonetizedUsers.vue?vue&type=script&lang=js"
export * from "./DashboardMonetizedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports